import React, { useState, useEffect } from 'react'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  Form,
  Message,
  InputNumber,
  IconButton,
  Icon,
  SelectPicker,
  Cascader,
  InputGroup,
  CheckPicker,
} from 'rsuite'
import { isValidators, requiredFiled, isRequired } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import InputForm from '../../../components/forms/input/InputForm'
import classNames from 'classnames'
import CKEditorFrom from '../../../components/forms/input/CKEditorFrom'
import { useForm, Controller } from 'react-hook-form'

export default function ReportResultProjectForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  valueOnEdit,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [indicatorsValues, setIndicatorsValues] = useState()
  const [indicatorsPlaceholder, setIndicatorsPlaceholder] = useState('กรุณาเลือกผลลัพธ์ก่อน')
  const [valCollection, setValCollection] = useState()
  const [valCollectionMethod, setValCollectionMethod] = useState()

  useEffect(() => {
    // handleSelectedResult(valueOnEdit?.resultId)
    if (valueOnEdit) {
      selectedResultOnEdit(valueOnEdit?.resultId)
    }
  }, [valueOnEdit])

  const selectedResultOnEdit = (resultId) => {
    const indicatorsValue = schema.resultIndicatorsOption.valuesOption.find(
      (result) => result.value === resultId
    )

    let newArrOption = [
      {
        disabled: false,
        label: 'เลือกทั้งหมด',
        value: 'all',
      },
    ]

    if (indicatorsValue.indicators) {
      indicatorsValue.indicators.map((item) => {
        newArrOption.push(item)
      })
    }

    setIndicatorsValues(newArrOption)
  }

  const handleSelectedResult = (resultId) => {
    // console.log('result id ', resultId)

    const indicatorsValue = schema.resultIndicatorsOption.valuesOption.find(
      (result) => result.value === resultId
    )

    let newArrOption = [
      {
        disabled: false,
        label: 'เลือกทั้งหมด',
        value: 'all',
      },
    ]

    if (indicatorsValue.indicators) {
      indicatorsValue.indicators.map((item) => {
        const tableViewDataRow = schema.tableView.find(
          (DataRow) => DataRow.indicatorId === item.value
        )

        if (!tableViewDataRow) {
          newArrOption.push(item)
        }
      })

      setIndicatorsPlaceholder(
        schema.resultIndicatorsOption.indicators.hint ||
          `${schema.resultIndicatorsOption.indicators.label}`
      )
    } else {
      newArrOption = []
    }

    if (newArrOption.length === 1 && newArrOption[0].value) {
      newArrOption = []
      setIndicatorsPlaceholder('ตัวชี้วัดถูกบันทึกไปแล้ว')
    }

    setIndicatorsValues(newArrOption)
  }

  const handleSelectedIndicators = (indicatorsId) => {
    // console.log('indicatorsId ', indicatorsId)
    const tableViewDataRow = schema.tableView.find(
      (DataRow) => DataRow.indicatorId === indicatorsId
    )

    if (tableViewDataRow?.infoStored) {
      setValCollection(tableViewDataRow.infoStored)
    } else {
      setValCollection(null)
    }

    if (tableViewDataRow.storageMethod) {
      setValCollectionMethod(tableViewDataRow.storageMethod)
    } else {
      setValCollectionMethod(null)
    }
  }

  return (
    <>
      <Form>
        <Row>
          <Col lg={24} md={24} sm={24} xs={24}>
            <ErrorMessage error={errors[schema.resultIndicatorsOption.result.name]} />

            <ControlLabel>
              {requiredFiled(
                schema.resultIndicatorsOption.result.validators,
                schema.resultIndicatorsOption.result.label
              )}
            </ControlLabel>
            <Controller
              key={schema.resultIndicatorsOption.result.name}
              name={schema.resultIndicatorsOption.result.name}
              control={control}
              rules={isValidators(schema.resultIndicatorsOption.result.validators)}
              // defaultValue={schema.resultOption.optionSelected}
              defaultValue={valueOnEdit?.resultId || null}
              render={(props) => {
                return (
                  <SelectPicker
                    data={schema.resultIndicatorsOption.valuesOption}
                    block
                    searchable={false}
                    placeholder={
                      schema.resultIndicatorsOption.result.hint ||
                      `เลือก${schema.resultIndicatorsOption.result.label}`
                    }
                    value={props.value}
                    onChange={(e) => {
                      console.log('e ', e)
                      handleSelectedResult(e)
                      // setSelectedResultId(e)
                      // setObjective(e)
                      setValue(schema.resultIndicatorsOption.result.name, e)
                      clearErrors(schema.resultIndicatorsOption.result.name)
                    }}
                  />
                )
              }}
            />
          </Col>
          <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: 10 }}>
            <ErrorMessage error={errors[schema.resultIndicatorsOption.indicators.name]} />

            <ControlLabel>
              {requiredFiled(
                schema.resultIndicatorsOption.indicators.validators,
                schema.resultIndicatorsOption.indicators.label
              )}
            </ControlLabel>
            <Controller
              key={schema.resultIndicatorsOption.indicators.name}
              name={schema.resultIndicatorsOption.indicators.name}
              control={control}
              rules={isValidators(schema.resultIndicatorsOption.indicators.validators)}
              // defaultValue={schema.resultOption.optionSelected}
              defaultValue={valueOnEdit?.indicatorId || null}
              render={(props) => {
                return (
                  <SelectPicker
                    data={indicatorsValues}
                    block
                    searchable={false}
                    placeholder={indicatorsPlaceholder}
                    value={props.value}
                    onChange={(e) => {
                      // setObjective(e)

                      setValue(schema.resultIndicatorsOption.indicators.name, e)
                      clearErrors(schema.resultIndicatorsOption.indicators.name)
                    }}
                  />
                )
              }}
            />
          </Col>

          <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
            <CKEditorFrom
              schema={schema.dataCollection}
              value={valueOnEdit?.infoStored}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
            <CKEditorFrom
              schema={schema.dataCollectionMethod}
              value={valueOnEdit?.storageMethod}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </Col>
        </Row>
      </Form>
    </>
  )
}
